<template>
    <section class="relative">
        <div class="absolute inset-0">
            <nuxt-img :width="backgroundImageWidth" :height="backgroundImageHeight" format="webp" :src="backgroundImageSrc" sizes="xs:330px sm:640px md:768vw lg:1024px xl:1600"
                alt="section image" class="object-cover w-full h-full" preload fetchpriority="high" loading="eager" />
        </div>

        <div class="relative z-10 grid grid-cols-12 py-10 lg:py-20 gap-x-8">
            <div class="items-center md:col-span-7 col-span-12 px-4 bg 2xl:ml-[calc((100vw_-_1280px)_/_2)] grid">
                <div class="lg:py-8 xl:py-0">
                    <div>
                        <nuxt-img :width="logoWidth" :height="logoHeight" format="webp" :src="logoSrc" sizes="xs:330px sm:440px md:373px lg:421px xl:421"
                            :alt="logoAlt" class="object-cover mx-auto mb-4" preload fetchpriority="high" loading="eager" />
                    </div>
                    <h1 class="mb-4 font-bold text-center text-white uppercase font-ww-regular h1" v-html="titleText"></h1>
                    <div class="text-center text-white textp" v-html="descriptionText"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    backgroundImageSrc: {
        type: String,
        default: "/assets/images/bg-hero-section.png"
    },
    backgroundImageWidth: {
        type: Number,
        default: 1600
    },
    backgroundImageHeight: {
        type: Number,
        default: 587
    },
    logoSrc: {
        type: String,
        default: "/assets/images/logo-cookie.png"
    },
    logoAlt: {
        type: String,
        default: "Lifeboost Coffee Logo"
    },
    logoWidth: {
        type: Number,
        default: 421
    },
    logoHeight: {
        type: Number,
        default: 161
    },
    scrollTarget: {
        type: String,
        default: "the-products"
    },
    primaryButtonColor: {
        type: String,
        default: "#d20130"
    },
    buttonText: {
        type: String,
        default: "ADD TO CART"
    },
    backgroundColor: {
        type: String,
        default: "#d20130"
    },
    lifeboostLink: {
        type: String,
        default: "https://lifeboostcoffee.com/"
    },
    lifeboostText: {
        type: String,
        default: "lifeboost"
    },
    productText: {
        type: String,
        default: "frosted sugar cookie"
    },
    callUsText: {
        type: String,
        default: "CALL US TOLL FREE"
    },
    phoneNumber: {
        type: String,
        default: "1-800-479-1596"
    },
    callUsLink: {
        type: String,
        default: "tel:1-800-479-1596"
    },
    titleText: {
        type: String,
        default: "Frosted Sugar Cookie"
    },
    descriptionText: {
        type: String,
        default: "Bold, robust, rich Arabica coffee and sweet, buttery frosted sugar cookies combine to offer you a cup filled with simple familiarity and incredibly satisfying flavor. <br/><br/> Often considered the most simple cookie, when flavors of frosted sugar cookies - rich, creamy butter, velvety vanilla, soft and subtle sweetness - collide with single origin, rainforest mountain shade grown, hand selected, perfectly roasted, premium coffee beans the result is a flavor overwhelmingly delicious and anything but ordinary."
    }
});

defineBuilderComponent({
    friendlyName: "Hero with Background",
    inputs: [
        {
            name: "backgroundImageSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/bg-hero-section.png"
        },
        {
            name: "backgroundImageWidth",
            type: "number",
            defaultValue: 1600
        },
        {
            name: "backgroundImageHeight",
            type: "number",
            defaultValue: 587
        },
        {
            name: "logoSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/logo-cookie.png"
        },
        {
            name: "logoAlt",
            type: "text",
            defaultValue: "Lifeboost Coffee Logo"
        },
        {
            name: "logoWidth",
            type: "number",
            defaultValue: 421
        },
        {
            name: "logoHeight",
            type: "number",
            defaultValue: 161
        },
        {
            name: "scrollTarget",
            type: "text",
            defaultValue: "the-products"
        },
        {
            name: "primaryButtonColor",
            type: "color",
            defaultValue: "#d20130"
        },
        {
            name: "buttonText",
            type: "text",
            defaultValue: "ADD TO CART"
        },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: "#d20130"
        },
        {
            name: "lifeboostLink",
            type: "url",
            defaultValue: "https://lifeboostcoffee.com/"
        },
        {
            name: "lifeboostText",
            type: "text",
            defaultValue: "lifeboost"
        },
        {
            name: "productText",
            type: "text",
            defaultValue: "frosted sugar cookie"
        },
        {
            name: "callUsText",
            type: "text",
            defaultValue: "CALL US TOLL FREE"
        },
        {
            name: "phoneNumber",
            type: "text",
            defaultValue: "1-800-479-1596"
        },
        {
            name: "callUsLink",
            type: "url",
            defaultValue: "tel:1-800-479-1596"
        },
        {
            name: "titleText",
            type: "richText",
            defaultValue: "Frosted Sugar Cookie"
        },
        {
            name: "descriptionText",
            type: "richText",
            defaultValue: "Bold, robust, rich Arabica coffee and sweet, buttery frosted sugar cookies combine to offer you a cup filled with simple familiarity and incredibly satisfying flavor. <br/><br/> Often considered the most simple cookie, when flavors of frosted sugar cookies - rich, creamy butter, velvety vanilla, soft and subtle sweetness - collide with single origin, rainforest mountain shade grown, hand selected, perfectly roasted, premium coffee beans the result is a flavor overwhelmingly delicious and anything but ordinary."
        }
    ]
});
</script>
